var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iw-input-select',{attrs:{"id":"select-packs-name","input-label":_vm.$t('select_pack'),"input-optional":false,"options":_vm.options,"default-value":_vm.options[0].value},on:{"update-value":_vm.selectPack}})}
var staticRenderFns = []

export { render, staticRenderFns }